export default __webpack_public_path__ + "static/media/MTcarpaEspecial_LateralIzq.ac668ce4.webp";